import type { MemberOfNodes, Organization, Team } from '@/types/account.types';

export const parseEntities = (memberOfNodes: MemberOfNodes) => {
  const teams: Team[] = [];
  const organizations: Organization[] = [];

  memberOfNodes.forEach(account => {
    const entity = account?.entity;

    if (!entity?.__typename) return;
    if (isOrganization(entity)) {
      organizations.push(entity);
    } else if (isTeam(entity)) {
      teams.push(entity);
    }
  });

  let organization: Organization;
  if (organizations[0]) organization = organizations[0];
  else organization = teams[0]?.organization as Organization;

  return {
    organization,
    teams: teams.sort(compareName)
  };
};

const isOrganization = (entity: any): entity is Organization =>
  entity?.__typename === 'Account_Organization';

const isTeam = (entity: any): entity is Team =>
  entity?.__typename === 'Account_Team';

const compareName = (a: Team, b: Team) => a.name.localeCompare(b.name);
